/**
 * @fileoverview Default Avatar Generator
 *
 * Uses DiceBear Avataaars style to generate deterministic cartoon avatars
 * from a seed string (typically user ID). Returns a URL pointing to the
 * DiceBear API.
 */

const DICEBEAR_BASE = 'https://api.dicebear.com/9.x/avataaars/svg';

/**
 * Generates a deterministic Avataaars avatar URL from a seed string.
 */
export function getDefaultAvatarUrl(seed: string, size = 80): string {
  return `${DICEBEAR_BASE}?seed=${encodeURIComponent(seed)}&size=${size}`;
}

/**
 * Returns the user's avatar URL, falling back to a generated one.
 */
export function getAvatarUrl(avatarUrl: string | null | undefined, seed: string, size = 80): string {
  return avatarUrl || getDefaultAvatarUrl(seed, size);
}
